"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jquery_1 = __importDefault(require("jquery"));
const app_1 = __importDefault(require("../app"));
class ModalPlugin {
    init() {
        (0, jquery_1.default)(document).on("click", ".modal a.in-modal", this.navigateInModal);
        (0, jquery_1.default)(document).on("show.bs.modal", ".modal", this.loadModalContent);
    }
    // eslint-disable-next-line class-methods-use-this
    destroy() {
        (0, jquery_1.default)(document).off("click", ".modal a.in-modal");
        (0, jquery_1.default)(document).off("show.bs.modal", ".modal");
    }
    loadModalContent(e) {
        const modal = (0, jquery_1.default)(this);
        const { relatedTarget } = e;
        if (!relatedTarget) {
            return;
        }
        const relatedTargetElem = (0, jquery_1.default)(relatedTarget);
        if (relatedTargetElem.data("modal-title")) {
            modal.find(".modal-title").text(relatedTargetElem.data("modal-title"));
        }
        if (relatedTargetElem.data("modal-href")) {
            modal.find(".modal-body").html('<i class="fa fa-fw fa-spin fa-spinner fa-3x">');
            jquery_1.default.get(relatedTargetElem.data("modal-href"), (data) => {
                modal.find(".modal-body").html(data);
                app_1.default.partialInit(modal.find(".modal-body").get(0));
            });
        }
    }
    navigateInModal(e) {
        e.stopImmediatePropagation();
        e.stopPropagation();
        e.preventDefault();
        const link = (0, jquery_1.default)(this);
        const modal = (0, jquery_1.default)(this).closest(".modal");
        if (link.data("modal-title")) {
            modal.find(".modal-title").text(link.data("modal-title"));
        }
        const linkHref = link.attr("href");
        if (linkHref) {
            modal.find(".modal-body").html('<i class="fa fa-fw fa-spin fa-spinner fa-3x">');
            jquery_1.default.get(linkHref, (data) => {
                modal.find(".modal-body").html(data);
                app_1.default.partialInit(modal.find(".modal-body").get(0));
            });
        }
        return false;
    }
}
exports.default = ModalPlugin;
app_1.default.loadAndRegister("ModalPlugin", () => new ModalPlugin());
